import { createTheme } from "@mui/material";
import OpenSansTtf from './OpenSansRegular.ttf'

export function getTheme(){

    const opensans = {
        fontFamily: 'Open Sans, sans-serif',
        fontStyle: 'normal',
        fontDisplay: 'block',
        fontWeight: 400,
        src: `
            local('Open Sans'), 
            local('OpenSans'), 
            url(${OpenSansTtf}) format('ttf');
        `,
    }

    const theme = createTheme({
        overrides: {
            MuiCssBaseline: {
                '@global': { '@font-face': opensans}
            }
        },
        typography: { fontFamily: 'Open Sans, sans-serif' },
        cssVariables: { colorSchemeSelector: "class" },
        colorSchemes: {
            light: {
                palette: {
                    primary: {
                        main: "#06569D",
                    },
                    error: {
                        main: "#DC0000",
                    },
                    text: {
                        primary: "#000000",
                    },
                    TableCell: {
                        border:"2px solid #FFFFFF", // "#7DAED3"
                        borderLeft: "2px solid #FFFFFF",
                        background: "#E9E9E9",
                        hover: "#D9D9D9",
                    },
                    NavigationBar: {
                        background: "#D9D9D9",
                    },
                    sortButton: {
                        background: '#BFBFBF',
                        text: '#06569D',
                        selectedText: '#FFFFFF',
                        hover: '#D9D9D9',
                        selected: '#06569D',
                        border: '1px solid #BFBFBF',
                        bottomBorder: '3px solid #E9E9E9',
                    },
                    NewChannelPage: {
                        subheader: '#E9E9E9',
                        background: '#E3E3E3',
                        foreground: '#ECECEC',
                    }
                },
            },
            dark: {
                palette: {
                    background: {
                        default: "#2e2e2e",
                        paper: "#2e2e2e",
                    },
                    primary: {
                        main: "#7DAED3",
                    },
                    error: {
                        main: "#DC0000",
                    },
                    TableCell: {
                        border: "2px solid #2c2c2c",
                        borderLeft: "2px solid #2c2c2c",
                        background: "#4a4a4a",
                        hover: "#353535",
                    },
                    NavigationBar: {
                        background: "#000000",
                    },
                    sortButton: {
                        background: '#414141',
                        text: '#FFFFFF',
                        selectedText: '#FFFFFF',
                        hover: '#353535',
                        selected: '#06569D',
                        border: '1px solid #414141',
                        bottomBorder: '3px solid #000000',
                    },
                    NewChannelPage: {
                        subheader: '#393939',
                        background: '#2E2E2E',
                        foreground: '#434343',
                    }
                },
            },
        },
        components: {
            MuiDataGrid: {
                styleOverrides: {
                    root: {
                        "--DataGrid-containerBackground":
                            "var(--mui-palette-primary-main)",
                    },
                    columnHeaders: {
                        color: "var(--mui-palette-secondary-contrastText)",
                    },
                    columnSeparator: {
                        color: "var(--mui-palette-secondary-contrastText)",
                    },
                    columnHeaderTitle: {
                        fontWeight: "bold",
                    },
                    sortIcon: {
                        color: "var(--mui-palette-secondary-contrastText)",
                    },
                    menuIconButton: {
                        color: "var(--mui-palette-secondary-contrastText)",
                    },
                    "cell--editing": {
                        backgroundColor:
                            "var(--mui-palette-background-default)",
                    },
                },
            },
        },
    });

    return theme
}
